// ─── localStorage / Session keys ─────────────────────────────────────────────

/** Key used to persist the session token in localStorage. */
export const SESSION_TOKEN_KEY = "cf-session-token";

/** Key used to persist serialised auth state in localStorage. */
export const AUTH_STORAGE_KEY = "constructorfleet-auth";

/** Key used to persist subscription data in localStorage. */
export const SUBSCRIPTIONS_STORAGE_KEY = "constructorfleet-subscriptions";

// ─── Environment guards ───────────────────────────────────────────────────────

/** True when the app is running under Vitest (MODE === 'test'). */
export const IS_TEST_MODE = import.meta.env.MODE === "test";

// ─── SPA route paths ─────────────────────────────────────────────────────────

export const ROUTES = {
  LOGIN: "/login",
  VERIFY: "/verify",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  DASHBOARD: "/dashboard",
  SETTINGS: "/settings",
  BILLING: "/billing",
  ADMIN: "/admin",
  ADMIN_USERS: "/admin/users",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

// ─── API path prefixes ────────────────────────────────────────────────────────

export const API_PATHS = {
  AUTH: "/api/auth",
  ADMIN: "/api/admin",
  WEBSITE: "/api/website",
} as const;
